import React from 'react';
import { Upload } from 'antd';
import { CloudUploadOutlined } from '@ant-design/icons';
import { colorConstants } from 'config/colorConstants';
import { sendNotification } from 'utils/helperMethods';

const { Dragger } = Upload;

type FileUploadProps = {
    onFileUpload: (file: File) => void;
    allowedFormats: string[];
    maxFileSizeInMB: number;
    onFileRemove?: () => void;
};
const FileUpload: React.FC<FileUploadProps> = ({ onFileUpload, allowedFormats, maxFileSizeInMB, onFileRemove }) => {
    return (
        <Dragger
            className="w-full !border !border-backgroundGreyAlt1 !rounded-md !px-2.5 py-7"
            name="file"
            multiple={false}
            accept={allowedFormats.join(',')}
            customRequest={({ file, onSuccess, onError }) => {
                const uploadedFile = file as File;
                // Simulate uploading and call the provided onSuccess to handle the file
                if (uploadedFile.size > maxFileSizeInMB * 1024 * 1024) {
                    onError?.(new Error(`File size exceeds ${maxFileSizeInMB}MB limit.`));
                    return;
                }
                const fileExtension = uploadedFile.name.split('.').pop() || '';
                if (!allowedFormats.includes(`.${fileExtension}`)) {
                    onError?.(new Error(`File format not allowed. Allowed formats are: ${allowedFormats.join(',')}.`));
                    return;
                }
                onSuccess?.('ok');
                onFileUpload(file as File);
            }}
            onRemove={(file) => {
                if (onFileRemove) {
                    onFileRemove();
                }
            }}
        >
            <p className="ant-upload-drag-icon">
                <CloudUploadOutlined style={{ fontSize: '24px', color: colorConstants.blackAlt }} />
            </p>
            <p className="ant-upload-text">Drag and Drop the file or Click here</p>
            <p className="ant-upload-hint">Maximum file size: {maxFileSizeInMB}MB</p>
        </Dragger>
    );
};

export default FileUpload;
